import React from "react";

import style from './style.module.css';

const Spacer = ({ size = 24 }) => {
    return (
        <div className={style[`spacer${size}`] || style.Spacer16}></div>
    );
}

export default Spacer;